import React, { useState, useEffect, useRef } from 'react';
import CommandPalette from './components/CommandPalette';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { authProvider } from './components/utils/authProvider';
import Layout from './components/layout/Layout';
import { UserPermissionsProvider } from './components/context/UserPermissionsContext';
import './App.css';
import Environment from "./components/utils/Environment";
import DCFileUpload from './components/dcFileUpload/DcFileUpload';
import Dashboard from './components/dashboard/Dashboard';
import StoreOrder from './components/dataLoad/l2Interface/transactional_Interface/store_order/StoreOrder';
import ItemFacility from "./components/dataLoad/master_data_interfaces/ItemFacility";
import NotFoundPage from "./components/common/NotFoundPage";
import { initializeFaro } from "./faro";
import FaroConfig from "./components/services/faro-config.service";
import Routing from './components/routing/Routing';
import SelfServiceContext from './components/selfService/selfServiceContex';
import LocationItemAsmt from './components/dataLoad/master_data_interfaces/LocationItemAsmt';
import ActiveInventory from './components/dataLoad/master_data_interfaces/ActiveInventory';
import ItemSub from './components/dataLoad/master_data_interfaces/ItemSub';
import LpnandSat from './components/dataLoad/master_data_interfaces/LpnandSat';
import Permission from './components/settings/Permission';
import Users from './components/settings/Users';
import Groups from './components/settings/Groups';
import A3Builder from './components/ieHub/A3Builder';
import A3Repository from './components/ieHub/A3Repository';
import A3Detail from './components/ieHub/A3Detail';
import ApiRunner from './components/selfService/ApiRunner';

function App() {
  const auth = authProvider();
  const { groups } = auth;
  console.log("Groups", groups);
  const basePath = Environment.getBasePath();
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);
  const hasInitializedFaroRef = useRef(false);

  // Effect to listen for the keyboard shortcut (Ctrl+K)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setIsPaletteOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  
  useEffect(() => {
    if (hasInitializedFaroRef.current) {
      return;
    }

    hasInitializedFaroRef.current = true;
    const faroConfig = FaroConfig.getInstance();

    faroConfig.getConfig().then((config) => {
      if (config.faro_enabled === "true") {
        initializeFaro();
      }
    }).catch((err) => {
      console.error('Error initializing Faro:', err);
    });
  }, []);
  if (!auth.accessToken) {
    auth.clearSession();
    return null;
  }

  return (
    auth.accessToken ? (
      <>
        <UserPermissionsProvider>
          <Router>
            <Routes>
              <Route path={basePath} element={<Layout/>}>
                <Route path="dashboard" element={<Dashboard/>} />
                <Route path="dc-file-upload/xdock-upload" element={<DCFileUpload activeTab={0} />} />
                <Route path="dc-file-upload/in02-upload" element={<DCFileUpload activeTab={1} />} />
                <Route path="dc-file-upload/routing-upload" element={<DCFileUpload activeTab={2} />} />
                <Route path="self-service/self-service-context" element={<SelfServiceContext activeTab={0} />}/>
                <Route path="self-service/self-service-context/:group/:subgroup" element={<SelfServiceContext activeTab={0} />}/>
                <Route path="self-service/:group/:subgroup" element={<SelfServiceContext activeTab={0} />}          />
                <Route path="self-service/api-runner" element={<ApiRunner />} />
                <Route path="data-load/store-order" element={<StoreOrder/>} />
                <Route path="data-load/appointment" element={<div className='under-construction'>Appointment - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/purchase-order" element={<div className='under-construction'>Purchase Order - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/item" element={<div className='under-construction'>Item - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/retail-store" element={<div className='under-construction'>Retail Store - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/vendor" element={<div className='under-construction'>Vendor - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/wholesale-store" element={<div className='under-construction'>Wholesale Store - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/transfer-customer" element={<div className='under-construction'>Transfer Customer - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/vendor-facility" element={<div className='under-construction'>Vendor Facility - UNDER CONSTRUCTION</div>} />
                <Route path="data-load/item-facility" element={<ItemFacility />} />
                <Route path="data-load/location-item-asmt" element={<LocationItemAsmt />} />
                <Route path="data-load/item-sub" element={<ItemSub />} />
                <Route path="data-load/active-inventory" element={<ActiveInventory />} />
                <Route path="data-load/lpn-sat" element={<LpnandSat />} />
                <Route path="routing" element={<Routing />} />
                <Route path="ie-hub/a3-builder" element={<A3Builder />} />
                <Route path="ie-hub/a3-repository" element={<A3Repository />} />
                <Route path="ie-hub/a3-repository/:a3Id" element={<A3Detail />} />
                <Route path="settings/users" element={<Users />} />
                <Route path="settings/groups" element={<Groups />} />
                <Route path="settings/permission" element={<Permission />} />
                <Route index element={<Navigate to="dashboard" />} />
              </Route>
              {/* Catch-all route for 404 pages - outside of Layout */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </UserPermissionsProvider>

        <CommandPalette isOpen={isPaletteOpen} setIsOpen={setIsPaletteOpen} />
      </>
    ) : (
      (() => {
        auth.clearSession();
        return null;
      })()
    )
  );
}

export default App;
